import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer, Zoom } from 'react-toastify';
//import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/admin.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
    <ToastContainer
      autoClose={8000}
      transition={Zoom}
      position="top-right"
      theme="dark" />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
